import React, { useState } from "react";
import { scrollTop } from "../../../functions";

import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBNavbarToggler,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";

import { Link } from "react-router-dom";

import logo from "../../../assets/img/logo.png";
import "./styles.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(true);

  const { pathname } = window.location;

  const toggleCollapse = () => {
    setIsOpen(!isOpen);

    const icon = document.querySelector(".navbar-toggler>span");
    if (isOpen) {
      icon.classList.remove("navbar-toggler-icon");
      icon.classList.add("fas", "fa-times");
    } else {
      icon.classList.remove("fas", "fa-times");
      icon.classList.add("navbar-toggler-icon");
    }
  };

  const handleNavigation = () => {
    toggleCollapse();
    scrollTop();
  };

  const goHome = () => {
    setIsOpen(true);
    scrollTop();
  };

  /**
   * Função responsável por marcar como ativo o menu de navegação
   * @param {String} path path da página
   * @param {String} title título da página
   */
  const isActive = (path, title) => {
    if (pathname.match(`/${path}/`) || pathname === path) {
      document.title = `${title} - Ceprevi Itapetininga`;

      return "active";
    }

    if (pathname === "/") document.title = "Ceprevi Itapetininga";
  };

  const renderDropdownToggle = (title, path) => {
    return (
      <MDBDropdownToggle nav caret id={isActive(path)}>
        <span className="mr-2">{title}</span>
      </MDBDropdownToggle>
    );
  };

  const renderDropdownItem = (path, title) => {
    return (
      <Link to={path} className="navlink-custom" style={{ padding: "0" }}>
        <MDBDropdownItem onClick={handleNavigation} id={isActive(path, title)}>
          {title}
        </MDBDropdownItem>
      </Link>
    );
  };

  return (
    <header className="header">
      <MDBNavbar light expand="lg">
        <MDBContainer>
          <MDBNavbarBrand>
            <Link to="/" onClick={goHome}>
              <img id="logo" src={logo} alt="Logo" />
            </Link>
          </MDBNavbarBrand>
          <MDBNavbarToggler onClick={toggleCollapse} />
          <MDBCollapse id="navbarCollapse3" isOpen={!isOpen} navbar>
            <MDBNavbarNav right>
              <MDBNavItem>
                <MDBDropdown>
                  {renderDropdownToggle("FUNDAÇÃO", "fundacao")}
                  <MDBDropdownMenu>
                    {renderDropdownItem("/fundacao/sobre", "Quem somos")}

                    {renderDropdownItem(
                      "/fundacao/deficiencia-visual",
                      "Deficiência Visual"
                    )}
                    {renderDropdownItem(
                      "/fundacao/transparencia",
                      "Transparência"
                    )}
                  </MDBDropdownMenu>
                </MDBDropdown>
              </MDBNavItem>

              <MDBNavItem>
                <MDBDropdown>
                  {renderDropdownToggle("NOSSA ATUAÇÃO", "nossa-atuacao")}
                  <MDBDropdownMenu>
                    {renderDropdownItem("/nossa-atuacao/noticias", "Notícias")}
                    {renderDropdownItem(
                      "/nossa-atuacao/pesquisas",
                      "Pesquisas"
                    )}
                    {renderDropdownItem("/nossa-atuacao/eventos", "Eventos")}
                    {renderDropdownItem("/nossa-atuacao/acoes", "Ações")}
                  </MDBDropdownMenu>
                </MDBDropdown>
              </MDBNavItem>

              <MDBNavItem>
                <MDBDropdown>
                  {renderDropdownToggle("IMPACTO", "impacto")}
                  <MDBDropdownMenu>
                    {renderDropdownItem(
                      "/impacto/historias-de-vida",
                      "Histórias de Vida"
                    )}
                    {renderDropdownItem("/impacto/depoimentos", "Depoimentos")}
                  </MDBDropdownMenu>
                </MDBDropdown>
              </MDBNavItem>

              <MDBNavItem>
                <MDBDropdown>
                  {renderDropdownToggle("COMO AJUDAR", "como-ajudar")}
                  <MDBDropdownMenu>
                    {renderDropdownItem(
                      "/como-ajudar/doacao",
                      "Seja Um Doador"
                    )}
                    {renderDropdownItem(
                      "/como-ajudar/servicos-voluntarios",
                      "Serviços Voluntários"
                    )}
                  </MDBDropdownMenu>
                </MDBDropdown>
              </MDBNavItem>

              <MDBNavItem>
                <MDBNavLink
                  to="/contato"
                  id={isActive("/contato", "Contato")}
                  onClick={handleNavigation}
                >
                  <div className="navlink-custom">CONTATO</div>
                </MDBNavLink>
              </MDBNavItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    </header>
  );
};

export default Header;
